import React from "react";
import Countdown from "react-countdown";

const CountDownOne = () => {
  // Renderer callback with condition
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <>
          <div className="time-count day">
            <span>{"00"}</span>Days
          </div>
          <div className="time-count hour">
            <span>{"00"}</span>hour
          </div>
          <div className="time-count min">
            <span>{"00"}</span>minute
          </div>
          <div className="time-count sec">
            <span>{"00"}</span>second
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="time-count day">
            <span>{days < 10 ? "10" + days : days}</span>Days
          </div>
          <div className="time-count hour">
            <span>{hours < 1 ? "00" + hours : hours}</span>hour
          </div>
          <div className="time-count min">
            <span>{minutes < 1 ? "00" + minutes : minutes}</span>minute
          </div>
          <div className="time-count sec">
            <span>{seconds < 1 ? "00" + seconds : seconds}</span>second
          </div>
        </>
      );
    }
  };

  return (
    <div className="coming-time">
      <Countdown date={Date.now() + 5000000} renderer={renderer} />
    </div>
  );
};

export default CountDownOne;
